import { ReactComponent as Search } from 'assets/icons/icon-search.svg';

export default Search;
